import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDays, Scale, RefreshCw, ClipboardCheck, Calculator } from 'lucide-react';
const items = [{
  icon: CalendarDays,
  title: '7-Day Feeding Reset Plan',
  description: 'A gentle, step-by-step way to bring calm back to mealtime.'
}, {
  icon: Scale,
  title: 'Portion Clarity Guide',
  description: 'Know exactly how much to feed — no more eyeballing it.'
}, {
  icon: RefreshCw,
  title: 'Smart Protein Rotation',
  description: 'Switch ingredients the right way, without upsetting their belly.'
}, {
  icon: ClipboardCheck,
  title: 'Weekly Check-In Method',
  description: "A simple way to see what', s, working(and, what, to, adjust) { }, .,"
}, {
  icon: Calculator,
  title: 'Bonus: Portion & Treat Calculator',
  description: "A handy printable so treats don', t, accidentally, throw: things, off, .,"
}];
export function WhatYouGetSection() {
  return <section id="whats-included" className="py-20 bg-[#F8FAFC]" data-id="element-226">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="max-w-4xl mx-auto" data-id="element-228">
          {/* Intro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-8" data-id="element-229">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B] mb-4" data-id="element-230">
              This Isn't Another Food Guide
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-xl border border-[#E2E8F0] p-8 md:p-10 mb-16" data-id="element-231">
            <p className="text-lg text-[#475569] leading-relaxed mb-4" data-id="element-232">
              The Smart Feeding System™ is a{' '}
              <span className="font-semibold text-[#1E293B]" data-id="element-233">
                simple 7-day plan
              </span>{' '}
              designed specifically for sensitive Frenchies.
            </p>
            <p className="text-lg text-[#475569] mb-2" data-id="element-234">
              No brand recommendations.
            </p>
            <p className="text-lg text-[#475569] mb-4" data-id="element-235">
              No trendy ingredient lists.
            </p>
            <p className="text-lg text-[#1E293B] font-semibold" data-id="element-236">
              Just a clear, repeatable routine you can follow every week.
            </p>
            <p className="text-[#0F766E] font-semibold mt-4" data-id="element-237">
              Because good feeding isn't about finding the perfect food — it's
              about building a routine that works.
            </p>
          </motion.div>

          {/* What You Get */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-238">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1E293B]" data-id="element-239">
              Here's What's Inside
            </h3>
          </motion.div>

          <div className="space-y-4" data-id="element-240">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 border border-[#E2E8F0] flex items-start gap-4" data-id="element-241">
                <div className="w-12 h-12 bg-[#F0FDFA] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-242">
                  <item.icon className="w-6 h-6 text-[#0F766E]" data-id="element-243" />
                </div>
                <div data-id="element-244">
                  <h4 className="text-lg font-semibold text-[#1E293B] mb-1" data-id="element-245">
                    {item.title}
                  </h4>
                  <p className="text-[#475569]" data-id="element-246">{item.description}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center text-[#475569] mt-8" data-id="element-247">
            Everything built around one idea: keep it consistent, keep it
            simple.
          </motion.p>
        </div>
      </div>
    </section>;
}